import React, { Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  Global404Certs,
  removeClassesForHidingElements,
  Route404,
} from '@saviynt/common';
import { OverlayProvider } from '@saviynt/design-system';

import hideHostElementsWrapper, {
  removeDynamicBodyClasses,
} from '../utils/hideHostElements';

import CertificationDetails from './CertificationDetails';
import CertificationList from './CertificationList';

function Routes() {
  const allowedRoutes = {
    staticRoutes: [],
    dynamicRoutes: [],
  };

  const { certsGen2, certsListGen2 } = useSelector((state) => state?.user);

  useEffect(() => {
    removeDynamicBodyClasses();
    hideHostElementsWrapper();

    return () => removeClassesForHidingElements();
  }, []);

  const certGen2Flag = certsGen2;
  const certsListGen2Flag = certsListGen2;

  // Allow cert details page
  if (certGen2Flag && parseInt(certGen2Flag, 10)) {
    allowedRoutes.staticRoutes = ['/certification/details'];
  }

  // Allow cert list page
  if (certsListGen2Flag && parseInt(certsListGen2Flag, 10)) {
    allowedRoutes.staticRoutes.push('/certification/list');
  }

  return (
    <Suspense key='Certs' fallback={() => {}}>
      <Router basename='/ECMv6'>
        <Route404
          routes={allowedRoutes}
          render={(path) => <Global404Certs path={path} />}>
          <Switch>
            <OverlayProvider>
              <Route
                exact
                path='/certification/details'
                component={CertificationDetails}
              />
              <Route
                exact
                path='/certification/list'
                component={CertificationList}
              />
            </OverlayProvider>
          </Switch>
        </Route404>
      </Router>
    </Suspense>
  );
}

export default Routes;
